export default __webpack_public_path__ + "static/media/crossApiaryDesktop.a575c3b4.jpg";